import type { ObjectTypeGroup } from '@/entities/Inventory/ObjectSubTypes'
import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'

export const PARENT_OBJECT_NAME_GRID_PREFIX = 'parent-obj-name:'

export function parentObjectNameGridId(parentGroupId: number): string {
  return `${PARENT_OBJECT_NAME_GRID_PREFIX}${Number(parentGroupId)}`
}

export function isParentObjectNameGridId(gridId: string): boolean {
  return String(gridId).startsWith(PARENT_OBJECT_NAME_GRID_PREFIX)
}

export function parseParentObjectNameGroupId(gridId: string): number | null {
  const s = String(gridId)
  if (!s.startsWith(PARENT_OBJECT_NAME_GRID_PREFIX)) return null
  const n = Number(s.slice(PARENT_OBJECT_NAME_GRID_PREFIX.length))
  return Number.isFinite(n) && n > 0 ? n : null
}

/**
 * Minimal inventory field row for layout/runtime resolution of the synthetic «Наименование объекта» cell.
 * `object_type` prefers the parent list’s child type id, then the first field in the parent group.
 */
export function syntheticParentObjectNameInventoryField(
  g: ObjectTypeGroup,
  fieldsInGroup: ObjectInventoryField[] = [],
): ObjectInventoryField {
  const fromList = Number(g.list_invent_object_type_id)
  const objectType =
    (Number.isFinite(fromList) && fromList > 0 ? fromList : 0) ||
    Number(fieldsInGroup[0]?.object_type) ||
    0
  return {
    id: parentObjectNameGridId(g.id),
    name: 'Наименование объекта',
    type: 'string',
    items: [],
    default_value: '',
    object_type: objectType,
    multiple: false,
    count_object: false,
    is_filtered: false,
    is_table: false,
    is_system: true,
    is_global_search: false,
    group: g.id,
  }
}
